import { SearchValueShow } from '@/components/ActiveSearchTags/types';

// Constants
const DEFAULT_CONCAT_CHAR = ', ';

/**
 * Format the search value for display
 */
export const formatSearchValue = (
  value: SearchValueShow['valueShow'],
  concatChar?: string
): string => {
  if (Array.isArray(value)) {
    return value.join(concatChar || DEFAULT_CONCAT_CHAR);
  }
  return String(value);
};
